import "./product-or-service-block.scss";